import axios from 'axios';
import { FeederBrand } from '../types/feeder-brand.type';

// GET BRANDS
// /ewosapi/v1/shrimps/Feed/${globalCompanyId}/brands
export const getBrands = async (globalCompanyId: string): Promise<FeederBrand[]> => {
  const res = await axios.get<FeederBrand[]>(`/ewosapi/v1/shrimps/feeder/${globalCompanyId}/brands`);
  return res.data;
};
